import * as React from "react"
import type { SVGProps } from "react"
const SvgSettingsCogFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M10.83 22q-.68 0-1.17-.45t-.59-1.1l-.22-1.65a4 4 0 0 1-.61-.3l-.57-.37-1.55.64q-.62.28-1.25.05a2 2 0 0 1-.97-.8l-1.18-2.04q-.35-.59-.2-1.23.15-.66.68-1.07l1.32-1-.02-.34v-.68l.02-.34-1.32-1a2 2 0 0 1-.68-1.07q-.15-.65.2-1.22L3.9 5.98q.35-.59.97-.8.63-.23 1.25.04l1.55.66a7 7 0 0 1 1.18-.68l.22-1.65q.1-.65.6-1.1.48-.45 1.15-.45h2.36q.67 0 1.16.45t.59 1.1l.22 1.65q.33.12.61.3.3.17.56.38l1.55-.66q.63-.27 1.25-.04.63.22.98.8l1.17 2.05q.35.57.2 1.22-.15.66-.67 1.07l-1.32 1 .02.34v.68q0 .15-.05.34l1.32 1q.54.42.68 1.07t-.2 1.22l-1.2 2.05q-.35.59-.98.8-.62.24-1.25-.05l-1.5-.64a7 7 0 0 1-1.17.67l-.22 1.65q-.1.65-.6 1.1-.48.45-1.15.45zm1.22-6.5q1.46 0 2.47-1.03A3.4 3.4 0 0 0 15.56 12q0-1.46-1.03-2.47a3.4 3.4 0 0 0-2.47-1.03q-1.47 0-2.49 1.03A3.4 3.4 0 0 0 8.55 12q0 1.46 1.01 2.47 1.01 1.03 2.49 1.03" />
  </svg>
)
export default SvgSettingsCogFilled
